/** Shared helpers for CredoraDataTable cell renderers. */

export function tableInitials(name) {
  if (!name || name === "—") {
    return "?";
  }
  const parts = name.trim().split(/\s+/).filter(Boolean);
  if (parts.length === 1) {
    return parts[0].slice(0, 2).toUpperCase();
  }
  return `${parts[0][0]}${parts[parts.length - 1][0]}`.toUpperCase();
}

export const DEFAULT_TABLE_CUSTOM_STYLES = {
  headCells: {
    style: {
      fontSize: "0.72rem",
      fontWeight: 600,
      textTransform: "uppercase",
      letterSpacing: "0.04em",
      color: "#6b7280",
    },
  },
  cells: {
    style: {
      fontSize: "0.85rem",
      paddingTop: "14px",
      paddingBottom: "14px",
    },
  },
};
